import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const colorForModule = (m: string) => {
  switch ((m || "").toUpperCase()) {
    case "STUDENT":
      return "primary";
    case "HOUSE_ASSIGN":
      return "error";
    case "SESSION_TRANSFER":
      return "secondary";
    case "GATE_PASS":
      return "warning";
    case "CERTIFICATE":
      return "success";
    case "COMPLAINT":
      return "warning";
    case "SUBJECT_ASSIGN":
      return "info";
    default:
      return "grey";
  }
};

const colorKeyForModule = (m: string) => {
  const c = colorForModule(m);
  return c === "grey" ? "grey.500" : `${c}.main`;
};

interface Props {
  items: Array<{ date: string; module: string; action?: string; title: string; description?: string; performedBy?: string }>;
}

const StudentTimeline: React.FC<Props> = ({ items }) => {
  return (
    <Box sx={{ position: "relative", pl: 2 }}>
      {items.map((it, idx) => (
        <Box key={idx} sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
          <Box sx={{ width: 16, display: "flex", justifyContent: "center", pt: 1 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: colorKeyForModule(it.module),
              }}
            />
          </Box>
          <Card variant="outlined" sx={{ flex: 1, ml: 1 }}>
            <CardContent>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {it.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {new Date(it.date).toLocaleString()}
              </Typography>
              {it.description && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {it.description}
                </Typography>
              )}
              <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
                Module: {it.module} {it.action ? `• ${it.action}` : ""} {it.performedBy ? `• ${it.performedBy}` : ""}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      ))}
    </Box>
  );
};

export default StudentTimeline;
